// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__KnUXb","vLegacy":"SelectSecondary_vLegacy__1MJRQ","error":"SelectSecondary_error__1M06g","disabled":"SelectSecondary_disabled__2s7Ad"};